/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import Table, { Column } from '@roo/roo/Table';
import Button from '@roo/roo/Button';
import Pagination from '@roo/roo/Pagination';
import Loading from '@roo/roo/Loading';
import AnalyseForm from './components/AnalyseForm';
import LiveAnalyseForm from './components/LiveAnalyseForm';
import {
    TABLE_TYPE,
    GetDownloadDetail,
    getAnalysisDownloadCount,
    getAnalysisDownloadLinkList,
    getProviderPermission,
    tableTypeMap,
    IMap,
    ILiveCustomerSources,
} from './api';
import utils from '@/utils/utils';
import './index.scss';

function Index() {
    const [tableData, setTableData] = useState<GetDownloadDetail[]>([]);
    const [pageCount, setPageCount] = useState<number>(0);
    const [pageNo, setPageNo] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(50);
    const [loading, setLoading] = useState<boolean>(false);
    // 直播报表权限
    const [permission, setPermission] = useState<boolean>(false);
    // 直播报表筛选项目
    const [liveCustomerSources, setLiveCustomerSources] = useState<ILiveCustomerSources[]>([]);
    // 下载列表需要展示时间范围的情况
    const shouldRenderRangeDateTypes = [
        TABLE_TYPE.DAILY,
        TABLE_TYPE.DISTRIBUTE,
        TABLE_TYPE.LIVEDAILY,
        TABLE_TYPE.LIVERESULT,
    ];

    const analysisDownloadCount = async () => {
        try {
            const res = await getAnalysisDownloadCount();
            setPageCount(res.data);
        } catch (e) {
            setPageCount(0);
        }
    };
    const analysisDownloadLinkList = async (curPage: number) => {
        try {
            const res = await getAnalysisDownloadLinkList({ pageNo: curPage, pageSize });
            setLoading(false);
            if (res.data) {
                setTableData(res.data);
                if (curPage !== pageNo) setPageNo(curPage);
            }
        } catch (e) {
            setTableData([]);
            setLoading(false);
        }
    };

    const handlePaginationChange = async (page: number) => {
        setLoading(true);
        await analysisDownloadCount();
        await analysisDownloadLinkList(page);
    };

    const initTableData = () => {
        handlePaginationChange(1);
    };

    // const onSubmit = async (value: SubmitReq) => {
    //     const res = await getAnalysisDownloadSubmit(value);
    //     initTableData();
    // };

    useEffect(() => {
        initTableData();
        initProviderPermission();
    }, []);

    const initProviderPermission = () => {
        getProviderPermission().then(res => {
            setPermission(res.data.permission);
            setLiveCustomerSources(res.data.customerSources);
        });
    };

    const columns: Column<GetDownloadDetail>[] = [
        {
            label: '操作时间',
            prop: 'ctime',
            render: (t: string) => {
                const dateObj = utils.timestampToMinutes(Number(t));
                return <span> {`${dateObj.date} ${dateObj.time}`}</span>;
            },
            align: 'center',
        },
        {
            label: '报表内容',
            render: (_text, record) => {
                const { type } = record;
                const title = (tableTypeMap as IMap)[type];
                let content = title;
                if (shouldRenderRangeDateTypes.includes(type)) {
                    content += `(${record.startDate}-${record.endDate})`;
                } else content += `(${record.queryDate})`;
                return content;
            },
            align: 'center',
        },
        {
            label: '下载文件',
            render: (_text, record) => {
                if (record.status === 0) return '生成中';
                return <a href={record.s3Link}>下载文件</a>;
            },
            align: 'center',
        },
    ];

    return (
        <div className="analysis-content">
            <AnalyseForm
                type={TABLE_TYPE.PERIOD}
                title={tableTypeMap[TABLE_TYPE.PERIOD]}
                buttonTitle="下载周期汇总表"
                updateTableData={initTableData}
                startDate="2021-03-01"
            />
            <AnalyseForm
                type={TABLE_TYPE.DAILY}
                title={tableTypeMap[TABLE_TYPE.DAILY]}
                buttonTitle="下载每日明细表"
                updateTableData={initTableData}
                startDate="2021-03-01"
                dateRange
            />
            <AnalyseForm
                type={TABLE_TYPE.RESULT}
                title={tableTypeMap[TABLE_TYPE.RESULT]}
                buttonTitle="下载运营结果汇总表"
                updateTableData={initTableData}
                startDate="2021-05-14"
            />
            <AnalyseForm
                type={TABLE_TYPE.DISTRIBUTE}
                title={tableTypeMap[TABLE_TYPE.DISTRIBUTE]}
                buttonTitle="下载分配商家明细表"
                updateTableData={initTableData}
                startDate="1970-01-01"
                dateRange
            />
            {permission && (
                <>
                    <LiveAnalyseForm
                        type={TABLE_TYPE.LIVEDAILY}
                        title={tableTypeMap[TABLE_TYPE.LIVEDAILY]}
                        updateTableData={initTableData}
                        customerSources={liveCustomerSources}
                    />
                    <LiveAnalyseForm
                        type={TABLE_TYPE.LIVERESULT}
                        title={tableTypeMap[TABLE_TYPE.LIVERESULT]}
                        updateTableData={initTableData}
                        customerSources={liveCustomerSources}
                    />
                </>
            )}
            <br />
            <p>
                下载任务
                <Button
                    disabled={loading}
                    type="text"
                    onClick={initTableData}
                    className="iconfont icon-wmb-refresh refresh"
                />
            </p>
            <Loading visible={loading} backdrop backdropStyle={{ background: 'rgba(0,0,0,0.02)' }}>
                <div className="table-pagation">
                    <Table columns={columns} data={tableData} emptyComponent="暂无数据" />
                    <Pagination
                        total={pageCount}
                        pageSize={pageSize}
                        currentPage={pageNo}
                        onChange={handlePaginationChange}
                    />
                </div>
            </Loading>
        </div>
    );
}

export default Index;
